<template>
	<b-container fluid>
		<b-row>
			<b-col>
				<h3 class='text-center'>Medical Exercise Scheduler</h3>
			</b-col>
		</b-row>
		<hr/>
		<b-row>
			<b-col lg>
				<UpcomingClasses />
			</b-col>
			<b-col lg>
				<Announcements />
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
// @ is an alias to /src
import UpcomingClasses from '@/components/Dashboard/UpcomingClasses'
import Announcements from '@/components/Dashboard/Announcements'

export default {
	name: "Dashboard",
	components: {
		UpcomingClasses,
		Announcements
	},
	methods: {
		checkLogin: function () {
			return new Promise ((resolve, reject) => {
				if (this.$store.state.token) {
					fetch(this.$apiURL + '/checkLogin', {
						method: "GET",
						headers: new Headers({
							'Authorization': this.$store.state.token,
							'Content-Type': 'application/json'
						})
					})
						.then(res => {
							if (res.ok) {
								// user is logged in
								res.json()
									.then(user => {
										this.$store.state.user.userID = user.userID
										this.$store.state.user.admin = user.admin
										resolve()
									})
							}
							else {
								this.$cookies.remove('token')
								this.$cookies.remove('userID')
								this.$cookies.remove('admin')
								window.location.replace('/login.html')
								reject()
							}
						})
				}
				else {
					this.$cookies.remove('token')
					this.$cookies.remove('userID')
					this.$cookies.remove('admin')
					this.$router.push('/Login')
					reject()
				}
			})
		}
	},
	async created() {
		await this.checkLogin()
	}
}
</script>
